<script setup lang="ts">
const props = defineProps({
  modalFunction: {
    type: Function || undefined,
    default: undefined,
    required: false,
  },
  imageSource: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  example: {
    type: String,
    required: true,
  },
  calendarType: {
    type: String,
    required: false,
  },
})

const handleClick = () => {
  if (props.modalFunction) {
    if (props.calendarType) {
      props.modalFunction(props.calendarType)
    } else {
      props.modalFunction()
    }
  }
}
</script>

<template>
  <div
    class="min-h-20 mx-2 mt-4 w-full cursor-pointer rounded-xl border border-gray-200 px-3 pt-2 pb-6 hover:border-blue-400 lg:w-[48%]"
    role="button"
    @click="handleClick"
    @keypress="handleClick"
  >
    <div class="pointer-events-auto">
      <slot />
    </div>
    <div class="flex items-start mt-3">
      <div class="flex">
        <img :src="imageSource" class="w-8" alt="" />
      </div>
      <div class="ml-3 flex w-full flex-col text-start">
        <div class="text-sm font-medium">
          {{ title }}
        </div>
        <div class="text-gray-400">
          {{ description }}
        </div>
        <div class="text-gray-400">
          {{ example }}
        </div>
      </div>
    </div>
  </div>
</template>
